import { Column } from "../../../../components/TableDataGridV2/types";
import { IDataAgronomo } from "../../../../types/api/geral/pesquisar-agronomo";

export const colunasAgronomos: Column<IDataAgronomo>[] = [
    {
        id: 'id',
        label: 'Código',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 80,
    },
    {
        id: 'nome',
        label: 'Nome',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'loja_id',
        label: 'Loja',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'crea',
        label: 'Crea',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'telefone',
        label: 'Telefone',
        type: "text",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    }
];


